import React, { Fragment } from 'react'

import CodeExamplesPage from '@/docs-partials/resources/code-examples.mdx'
import SupportPage from '@/docs-partials/resources/support.mdx'
import ApiExplorerPage from '@/docs-partials/resources/api-explorer.mdx'
import { DocsSection } from '@/components/common/docs-section'

const Resource = () => {
  return (
    <Fragment>
      <div>
        <DocsSection anchorId="code-examples" dividerLine={false}>
          <CodeExamplesPage />
        </DocsSection>
        <DocsSection anchorId="support">
          <SupportPage />
        </DocsSection>
        <DocsSection>
          <ApiExplorerPage anchorId="api-explorer" />
        </DocsSection>
      </div>
    </Fragment>
  )
}

export default Resource
